import { forwardRef, useCallback } from 'react'
import { Keyboard, Platform } from 'react-native'
import { useRouter } from 'expo-router'
import { ReduceMotion } from 'react-native-reanimated'
import BottomSheet, { BottomSheetBackdrop } from '@gorhom/bottom-sheet'

import { DS } from '@/design-system'
import { styles } from '@/components/JoinGameSheet/styles'
import { isWeb, useMaxWidth } from '@/components/WebWrapper'
import { useRemoteConfig } from '@/modules/remote-config'
import { SupportForm, type SupportFormProps } from '@/components/Support/SupportForm'

// Note the default for `shouldRoute`. Could remove these props.
export const SupportScreen = forwardRef<BottomSheet, Omit<SupportFormProps, 'onClose'>>(
  ({ placeHolder, shouldRoute = true }: SupportFormProps, ref) => {
    const router = useRouter()
    const maxWidth = useMaxWidth()

    const onClose = useCallback(() => {
      if (shouldRoute) {
        if (router.canDismiss()) {
          return router.dismiss()
        }
        router.dismiss()
      }
    }, [router, shouldRoute])

    const renderBackdrop = useCallback(
      (props: React.ComponentProps<typeof BottomSheetBackdrop>) => (
        <BottomSheetBackdrop
          {...props}
          pressBehavior={'close'}
          disappearsOnIndex={-1}
          appearsOnIndex={0}
          onPress={() => {
            requestAnimationFrame(() => {
              Keyboard.dismiss()
            })
          }}
        />
      ),
      []
    )

    return (
      <BottomSheet
        ref={ref}
        onClose={onClose}
        enableDynamicSizing={true}
        maxDynamicContentSize={700}
        enableContentPanningGesture
        enableHandlePanningGesture
        enablePanDownToClose
        keyboardBehavior={Platform.OS === 'android' ? 'extend' : 'interactive'}
        keyboardBlurBehavior="none"
        android_keyboardInputMode="adjustResize"
        detached={false}
        handleStyle={styles.bottomSheetHandleStyle}
        handleIndicatorStyle={styles.bottomSheetIndicatorStyle}
        backgroundStyle={{ backgroundColor: DS.palette['Brand/Cream'] }}
        backdropComponent={renderBackdrop}
        overrideReduceMotion={ReduceMotion.System}
        style={{
          marginBottom: 64,
          marginHorizontal: isWeb ? 'auto' : undefined,
          maxWidth: maxWidth,
          width: '100%'
        }}
      >
        <SupportForm placeHolder={placeHolder} shouldRoute={true} />
      </BottomSheet>
    )
  }
)
